import PropTypes from "prop-types";
import css from "../styles_web/HeaderProfile.module.css";
import StorefrontIcon from "@mui/icons-material/Storefront";
import Image from "../components/shared/Image";

/************************************/
/* SPA Logo */
/************************************/

const SpaLogo = ({ storeName, storeLogo }) => {
  return (
    <div className={css["profile"]}>
      <div className={css["content"]}>
        <button className={css["button"]}>
          <div className={css["button-content"]}>
            {storeLogo && (
              <div className={css["storeLogo"]}>
                <Image src={storeLogo} alt="logo" noCache={true} />
              </div>
            )}
            {!storeLogo && storeName && (
              <span className={css["storename"]}>
                <span className={css["storeicon"]}>
                  <StorefrontIcon fontSize="small" />
                </span>{" "}
                {storeName}
              </span>
            )}
          </div>
        </button>
      </div>
    </div>
  );
};

SpaLogo.propTypes = {
  storeName: PropTypes.string,
};

export default SpaLogo;
